module.exports = __webpack_public_path__ + "img/IcnMember.5c525abc.png";